import type { MessageDescriptor } from 'react-intl';
import messages from './messages';

const NON_DORMAKABA_RFID_ERROR_MESSAGE = 'RFID creation forbidden - non-dormakaba card';
const NO_RFID_SLOT_AVAILABLE_STATUS = 409;

interface IApiError {
  data?: {
    message?: string;
  };
  status?: number;
}

function isApiError(error: unknown): error is IApiError {
  return typeof error === 'object' && error !== null;
}

export function getCreateUserRfidErrorMessage(error: unknown): MessageDescriptor {
  if (!isApiError(error)) {
    return messages.siteSettingsGeneralError;
  }

  if (error.data?.message === NON_DORMAKABA_RFID_ERROR_MESSAGE) {
    return messages.userRfidModalScanQrMsgErrCardNotRegistered;
  }

  if (error.status === NO_RFID_SLOT_AVAILABLE_STATUS) {
    return messages.credentialAssignFailed;
  }

  return messages.siteSettingsGeneralError;
}
